import "./style.css";

import { Routes, Route, useParams, Navigate } from "react-router";

import { useTranslation } from "react-i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import Main from "./Main";
import Login from "./Login";
import ResetPassword from "./Login/ResetPassword";
import Signup from "./Signup";
import { useAppSelector } from "store";
import ShortBar from "./ShortBar";
import { useEffect } from "react";
import Confirm from "./Confirm";
import Credits from "./Credits";

export default function Landing() {
    const token = useAppSelector((state) => state.auth.token);
    const { i18n } = useTranslation();
    let { locale } = useParams();

    useEffect(() => {
        if (locale === "en" || locale === "fr") {
            i18n.changeLanguage(locale);
            localStorage.setItem("language", locale);
        }
    }, []);

    return (
        <div id="landing" className="landing">
            <Routes>
                <Route path="credits" element={<Credits />} />
                <Route
                    path=""
                    element={
                        <>
                            <ShortBar />
                            <Navbar />
                            <Header />
                            <Main />
                            <Footer />
                            <ToastContainer />
                        </>
                    }
                />
                <Route
                    path="login"
                    element={token ? <Navigate to="/app" replace /> : <Login />}
                />
                <Route
                    path="confirm"
                    element={
                        token ? <Navigate to="/app" replace /> : <Confirm />
                    }
                />
                <Route
                    path="reset_password/:token"
                    element={<ResetPassword />}
                />
                <Route
                    path="signup"
                    element={
                        token ? <Navigate to="/app" replace /> : <Signup />
                    }
                />
            </Routes>
        </div>
    );
}
